import { css } from '@emotion/react';
import veevaIdLogo from '../images/veeva-id-logo.svg';
import useMessageService from '../services/i18n/useMessageService';
import { useAppMetadataContext } from './AppMetadataContextWrapper';

const BrandedLogo = () => {
    const [[veevaIdLogoAlt = 'VeevaID logo']] = useMessageService([
        'branded_logo.veeva_id_logo_alt',
    ]);

    const { appMetadata, isNonVaultApp } = useAppMetadataContext();

    const nonVaultAppName = isNonVaultApp ? appMetadata?.app_name : undefined;

    return (
        <div
            role="img"
            css={css`
                display: flex;
                align-items: center;
                flex-direction: column;
                gap: 8px;

                & > img {
                    height: 2.5rem;
                }
            `}
        >
            <img src={veevaIdLogo} alt={veevaIdLogoAlt} />
            {nonVaultAppName && (
                <span
                    css={css`
                        font-size: 1.667rem;
                    `}
                >
                    <strong>{nonVaultAppName}</strong>
                </span>
            )}
        </div>
    );
};

export default BrandedLogo;
